import { Injectable } from "@angular/core";
import { GlobalConstants } from "src/app/constants";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import * as moment from "moment";
import {
  EmployeeMaster,
  EmployeeMasterAdapter,
} from "../Model/employee-master";

@Injectable({
  providedIn: "root",
})
export class EmployeeMasterService {
  private baseURL =
    GlobalConstants.BASE_API_URL + ":" + GlobalConstants.BASE_API_URL_PORT;
  private API_NAME = "employeeMaster";

  constructor(
    private httpClient: HttpClient,
    private adapter: EmployeeMasterAdapter
  ) {}

  getAll(): Observable<EmployeeMaster[]> {
    const url = `${this.baseURL}/${this.API_NAME}/api/get/all`;
    return this.httpClient.get(url).pipe(
      // Adapt each item in the raw data array
      map((data: any[]) => data["data"].map((item) => this.adapter.adapt(item)))
    );
  }

  checkForDuplicate(employeeNumber): Observable<EmployeeMaster[]> {
    // Creation duplicate check, since no ID.  No need to check by ID
    const url = `${this.baseURL}/${this.API_NAME}/api/get/byEmployee`;
    const params = new HttpParams().set("employeeNumber", employeeNumber);
    return this.httpClient.get(url, { params }).pipe(
      // Adapt each item in the raw data array
      map((data: any[]) => data["data"].map((item) => this.adapter.adapt(item)))
    );
  }

  update(formData) {
    const url = `${this.baseURL}/${this.API_NAME}/api/update`;
    return this.httpClient.post(url, formData);
  }

  delete(employeeNumber) {
    const url = `${this.baseURL}/${this.API_NAME}/api/delete`;
    return this.httpClient.post(url, { employeeNumber: employeeNumber });
  }

  create(formData) {
    const url = `${this.baseURL}/${this.API_NAME}/api/create`;
    return this.httpClient.post(url, formData);
  }
}
